const img = require('./Classic.png'); export default img;